module.exports = __webpack_public_path__ + "img/mediaIcon2.b022631e.png";